// Układy etykiet do druku (2026-09-24). Wymiary w MILIMETRACH — dokładnie jak na opakowaniu
// arkusza, bo przesunięcie o 2 mm przy 24 etykietach na stronie trafia już na krawędź sąsiedniej.
//
// Arkusze A4 to popularne formaty samoprzylepne (70 × 37, 70 × 42,3, 38,1 × 21,2). Rolki to
// drukarki etykiet (Zebra, Brother QL, Dymo) — jedna etykieta = jedna „strona" w sterowniku.

export const LABEL_LAYOUTS = {
  'a4-24': { kind: 'sheet', page: { w: 210, h: 297 }, cols: 3, rows: 8, label: { w: 70, h: 37 }, margin: { top: 0.5, left: 0 }, gap: { x: 0, y: 0 } },
  'a4-21': { kind: 'sheet', page: { w: 210, h: 297 }, cols: 3, rows: 7, label: { w: 70, h: 42.3 }, margin: { top: 0.45, left: 0 }, gap: { x: 0, y: 0 } },
  'a4-65': { kind: 'sheet', page: { w: 210, h: 297 }, cols: 5, rows: 13, label: { w: 38.1, h: 21.2 }, margin: { top: 10.7, left: 4.75 }, gap: { x: 2.5, y: 0 } },
  // Brother (np. QL i TD) na etykietach 45 × 30 mm, szerokość × wysokość (26.10.2026).
  'roll-45x30': { kind: 'roll', page: { w: 45, h: 30 }, cols: 1, rows: 1, label: { w: 45, h: 30 }, margin: { top: 0, left: 0 }, gap: { x: 0, y: 0 } },
  'roll-50x30': { kind: 'roll', page: { w: 50, h: 30 }, cols: 1, rows: 1, label: { w: 50, h: 30 }, margin: { top: 0, left: 0 }, gap: { x: 0, y: 0 } },
  'roll-62x29': { kind: 'roll', page: { w: 62, h: 29 }, cols: 1, rows: 1, label: { w: 62, h: 29 }, margin: { top: 0, left: 0 }, gap: { x: 0, y: 0 } },
};

export const DEFAULT_LAYOUT = 'a4-24';
export const MAX_COPIES = 10;

export function perPage(layout) {
  return layout.cols * layout.rows;
}

/** Lewy górny róg pola `index` na stronie (mm). */
export function slotPosition(layout, index) {
  const col = index % layout.cols;
  const row = Math.floor(index / layout.cols);
  return {
    left: layout.margin.left + col * (layout.label.w + layout.gap.x),
    top: layout.margin.top + row * (layout.label.h + layout.gap.y),
  };
}

/**
 * Rozkłada etykiety na strony. `skip` zostawia puste pola na POCZĄTKU pierwszego arkusza —
 * na napoczęty arkusz, z którego już odklejono kilka naklejek (inaczej każdy druk marnowałby
 * resztę arkusza). Na rolce pomijanie nie ma sensu, więc jest ignorowane.
 * Zwraca tablicę stron; strona to tablica pól (`null` = puste pole).
 */
export function paginateLabels(items, { layout, copies = 1, skip = 0 }) {
  const n = perPage(layout);
  const kopie = Math.min(Math.max(1, Math.floor(Number(copies) || 1)), MAX_COPIES);
  const pomin = layout.kind === 'sheet' ? Math.min(Math.max(0, Math.floor(Number(skip) || 0)), n - 1) : 0;

  const slots = [];
  for (let i = 0; i < pomin; i += 1) slots.push(null);
  for (const item of items) for (let k = 0; k < kopie; k += 1) slots.push(item);
  if (slots.length === pomin) return [];

  const pages = [];
  for (let i = 0; i < slots.length; i += n) pages.push(slots.slice(i, i + n));
  return pages;
}
